export function Footer() {
  return (
    <footer className={"p-4 bg-white"}>
      <p className={"text-center text-gray-400 text-xs"}>
        Made with ❤️ in Bologna
      </p>
    </footer>
  );
}
